import styled from "styled-components";

export const ContentModal = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const ContentModalActiveSurvey = styled.div`
  background: ${({ theme }) => theme.primaryBackgroundLight};
  border: 1px solid ${({ theme }) => theme.neutral.gray[700]};
  box-sizing: border-box;
  box-shadow: 2px 2px 25px ${({ theme }) => theme.shadows.strong};
  width: 410px;
  height: 450px;
  border-radius: 8px;
  display: flex; /* Added display: flex */
  flex-direction: column; /* Added flex-direction: column */
  justify-content: space-evenly; /* Center horizontally */
  align-items: center; /* Center vertically */
  .img {
    width: 340px;
    height: 316px;
    flex-shrink: 0;
    text-align: center; /* Center the text */
  }
`;
export const Label1 = styled.div`
  color: ${({ theme }) => theme.primary.purple};
  font-size: 22px;
  font-style: normal;
  font-weight: 700;
  text-align: center; /* Center the text */
`;

export const Label2 = styled.div`
  color: ${({ theme }) => theme.primary.purple};
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  text-align: center; /* Center the text */
`;

export const Button = styled.button`
  display: flex;
  width: 113px;
  height: 32px;
  padding: 11px 32px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
  border-radius: 4px;
  border: 1px solid #b6005c;
  background-color: transparent;
  .button {
    color: ${({ theme }) => theme.primary.purple};
    text-align: center;
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
  }
  &:hover {
    box-shadow: ${({ theme }) => theme.button.buttonHoverShadow};
    transform: translateY(-1px);
    cursor: pointer;
  }
`;
